"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This feature can be used by creating a new file with something like:
 * ```
 * export const MyCustomPersistenceService = new PersistenceService<MyCustomApplicationModel>();
 * ```
 * There is also a simplified version in {@linkcode SimplePersistenceService}.
 */
var PersistenceService = /** @class */ (function () {
    function PersistenceService() {
        this.data = {};
    }
    PersistenceService.prototype.set = function (key, value) {
        if (this.isSessionPresent) {
            this.remove(key);
            window.sessionStorage.setItem(key, JSON.stringify(value));
        }
        this.assign(key, value);
    };
    PersistenceService.prototype.get = function (key, defaultValue) {
        if (defaultValue === void 0) { defaultValue = {}; }
        if (!this.data[key]) {
            if (window.sessionStorage.getItem(key)) {
                var value = JSON.parse(window.sessionStorage.getItem(key) || '{}');
                this.assign(key, value);
            }
            else {
                this.assign(key, defaultValue);
            }
        }
        return this.data[key];
    };
    PersistenceService.prototype.remove = function (key) {
        if (this.isSessionPresent) {
            window.sessionStorage.removeItem(key);
        }
        delete this.data[key];
    };
    PersistenceService.prototype.assign = function (key, value) {
        if (this.data[key]) {
            Object.assign(this.data[key], value);
        }
        else {
            this.data[key] = value;
        }
    };
    Object.defineProperty(PersistenceService.prototype, "isSessionPresent", {
        get: function () {
            var test = 'fkui.sessionstorage.test';
            try {
                if (window.sessionStorage) {
                    window.sessionStorage.setItem(test, 'test');
                    window.sessionStorage.removeItem(test);
                    return true;
                }
                else {
                    return false;
                }
            }
            catch (e) {
                /* Safari on iOS throws security exceptions when accessing
                 * sessionstorage in private browsing. */
                return false;
            }
        },
        enumerable: true,
        configurable: true
    });
    return PersistenceService;
}());
exports.PersistenceService = PersistenceService;
//# sourceMappingURL=PersistenceService.js.map